import { Component } from '@angular/core';
import { AuthService } from './shared/services/auth-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    private _authService: AuthService
  ){
    
  }
  title = 'proposal-ingestion-tool';
}
